import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import GoogleMap from 'react-google-map';

import { SR_API_ACTION_GET_USER_BY_PHONE } from 'api/actionTypes';

import Navbar from 'client/components/Navbar';

import { SCREEN_ID_USER_MAP_AREA } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withGoogleMaps from 'client/helpers/withGoogleMaps';
import branch from 'client/core/branch';

@withTransitionHook
@withScreenId(SCREEN_ID_USER_MAP_AREA)
@withGoogleMaps
@branch({})
class UserMapArea extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    apiClient: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...queryString.parse(props.location.search),
    };
  }

  _onLoadedMap = (googleMaps, map) => {
    this.map = map;
    this._loadUser();
  };

  _loadUser() {
    const { userPhone } = this.state;
    const { apiClient, googleMaps } = this.props;

    if (!userPhone) {
      return;
    }

    apiClient.post(SR_API_ACTION_GET_USER_BY_PHONE, { phone: userPhone }).then((user) => {
      if (this._isUnmounting) {
        return;
      }
      if (!user) {
        global.alert(`User with phone "${userPhone}" not found.`);
        return;
      }

      const polygon = new googleMaps.Polygon({
        paths: user.searchFilters.area.map((coord) => ({
          lng: coord[0],
          lat: coord[1],
        })),
        fillColor: '#193340',
        fillOpacity: 0.13,
        strokeColor: '#193340',
        strokeWeight: 2,
      });

      polygon.setMap(this.map);

      const bounds = Array.from(user.searchFilters.area).reduce(
        (bound, coord) => bound.extend(new googleMaps.LatLng(coord[1], coord[0])),
        new googleMaps.LatLngBounds(),
      );
      this.map.fitBounds(bounds);
    });
  }

  render() {
    const { googleMaps } = this.props;
    const { userPhone } = this.state;

    return (
      <div className="page-listing">
        <div className="listing-map">
          <Navbar />

          <div>
            {userPhone ? (
              <div className="mapContainer">
                <div className="innerMapContainer">
                  <GoogleMap
                    googleMaps={googleMaps}
                    center={{
                      lat: 30.170061,
                      lng: -97.749222,
                    }}
                    zoom={13}
                    disableDefaultUI
                    gestureHandling="greedy"
                    clickableIcons={false}
                    onLoaded={this._onLoadedMap}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

UserMapArea.displayName = 'UserMapArea';

export default UserMapArea;
